import type { avvio as it } from "../it/avvio.ts";

/** Avvio, configurazione e migrazioni: li legge chi installa e gestisce Portman. */
export const avvio: typeof it = {
  "avvio.serveChiave":
    "Need a master key? Generate one with:\n" +
    "  bun run keygen\n" +
    "and set it in PORTMAN_MASTER_KEY (keep it safe: without it, stored secrets can't be recovered).",
  "avvio.permessiLarghi": (p: { cosa: string }) => `${p.cosa} is readable by other users on this machine`,
  "avvio.fileChiave": "the master key file",
  "avvio.fileEnv": "the .env file, which holds the master key,",
  "avvio.migrazioniApplicate": "migrations applied",
  "avvio.operazioniInterrotte": "operations interrupted by a previous restart",
  "avvio.puliziaCredenziali": "cleanup of orphaned credentials failed",
  "avvio.inAscolto": "Portman is listening",
  "avvio.primoAvvio":
    "no users configured: open Portman in the browser to create the first administrator, " +
    "using this setup token",
  "avvio.sessioniScadute": "expired sessions removed",
  "avvio.arresto": "shutting down",
  "avvio.guasto": "operation ended with a failure",
  "avvio.richiestaFallita": "request failed",
  "avvio.interrottaDaRiavvio": "operation interrupted by a Portman restart",

  "config.nonValida": (p: { problemi: string }) => `Invalid configuration:\n${p.problemi}`,
  "config.campoGenerico": "configuration",
  "config.chiaveObbligatoria": "is required",
  "config.chiaveBase64": "must be base64-encoded",
  "config.chiaveByte": (p: { byte: number }) => `must decode to exactly ${p.byte} bytes`,
  "config.tokenCorto": "must be at least 16 characters long",
  "config.npmIncompleto":
    "Nginx Proxy Manager needs all three variables: " +
    "PORTMAN_NPM_URL, PORTMAN_NPM_IDENTITY and PORTMAN_NPM_SECRET",
  "config.poolInvertito": "the port pool can't start after its end",
  "config.dueForme": (p: { variabile: string; file: string }) =>
    `${p.variabile}: set both directly and via ${p.file}, pick one`,
  "config.fileIlleggibile": (p: { variabile: string; percorso: string }) =>
    `${p.variabile}: can't read "${p.percorso}"`,

  "migrazioni.duplicata": (p: { versione: number }) => `two migrations share version ${p.versione}`,
  "migrazioni.cambiata": (p: { migrazione: string }) =>
    `migration ${p.migrazione} has already been applied but its content has changed. ` +
    "Applied migrations are immutable: add a new one instead of editing it.",
  "migrazioni.fallita": (p: { migrazione: string; dettaglio: string }) =>
    `migration ${p.migrazione} failed: ${p.dettaglio}`,
  "migrazioni.nomeNonValido": (p: { file: string }) =>
    `invalid migration name: ${p.file} (expected format NNN_name.sql)`,
};
